var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":"https://upload.qbox.me","data":_vm.dataObj,"drag":"","multiple":true,"before-upload":_vm.beforeUpload}},[_c('i',{staticClass:"el-icon-upload"}),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }